import getAPIBaseUrl from './getAPIbaseURL';

const trimSlashes = (value: string) => value.replace(/^\/+|\/+$/g, '');

export const normalizeGameImageUrl = (value?: string | null): string => {
  const imagePath = value?.trim();

  if (!imagePath) {
    return '';
  }

  if (/^(https?:)?\/\//i.test(imagePath) || imagePath.startsWith('data:') || imagePath.startsWith('blob:')) {
    return imagePath;
  }

  const normalizedPath = trimSlashes(imagePath);
  const uploadPath = normalizedPath.startsWith('uploads/')
    ? `/${normalizedPath}`
    : `/uploads/${normalizedPath}`;

  const apiBaseUrl = getAPIBaseUrl();

  if (!apiBaseUrl) {
    return uploadPath;
  }

  try {
    return new URL(uploadPath, apiBaseUrl).toString();
  } catch {
    return uploadPath;
  }
};
